import styled from 'styled-components';
import AlertIcon from 'components/icons/AlertIcon';
import ChevronIcon from 'components/icons/ChevronIcon';
import { PanelLight } from './common';

interface InfoBannerProps {
  title?: string;
  text: string;
  link?: string;
  blueVariant?: boolean;
}

export default function InfoBanner({ title, text, link, blueVariant = false }: InfoBannerProps) {
  const alertIconProps = blueVariant
    ? { style: { marginTop: '5px' }, iconColor: '#0751C2', iconOpacity: 0.25 }
    : { style: { marginTop: '5px' } };
  const PanelComponent = blueVariant ? BluePanel : Panel;

  return (
    <PanelComponent>
      <AlertIcon {...alertIconProps} />
      {title && <PanelHeader>{title}</PanelHeader>}
      <PanelMessage>{text}</PanelMessage>
      {link && (
        <LinkWithIcon href={link}>
          <>
            View insurance status <ChevronIcon />
          </>
        </LinkWithIcon>
      )}
    </PanelComponent>
  );
}

const Panel = styled(PanelLight)`
  border-radius: 10px;
  border: 1px solid rgba(189, 227, 253, 0.768684);
  box-shadow: 0px 5px 22px -2px rgba(0, 0, 0, 0);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1em;
`;

const BluePanel = styled(PanelLight)`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1em;
  background: #ffffff;
  border: 1px solid #dbdfe5;
`;

const LinkWithIcon = styled.a`
  color: #0e7873 !important;
  grid-column: 2;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  align-content: center;
`;
const PanelHeader = styled.span`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  grid-column: 2;
`;

const PanelMessage = styled.p`
  grid-column: 2;
`;
